// R-NAV-2 — "coming soon" placeholder page.
//
// Renders for every not-yet-built sidebar destination (PLACEHOLDER_ROUTES).
// The navigation structure is final and correct; the real content lands in
// the owning sub-R (R-SIS, R-ASSESS, …). A clean, titled placeholder — never
// a dead link or a 404 — per the owner's complete-and-correct rule.
//
// Title is derived from the current route via PLACEHOLDER_ROUTES so a single
// component serves every placeholder (no per-page boilerplate).
import React from "react";
import { Icon } from "../icons";
import { Button, EmptyState } from "../ui";
import { useCurrentRoute, type Go } from "../router";
import { getPlaceholder } from "../router/placeholder-routes";
import { useRole } from "../role";

export interface ComingSoonProps {
  go: Go;
}

const ComingSoonPage = ({ go }: ComingSoonProps): React.ReactElement => {
  const { id, param } = useCurrentRoute();
  const { role, activeRoleId } = useRole();
  // pathKey = first two segments, matching PLACEHOLDER_ROUTES keys.
  const pathKey = param ? `${id}/${param.split("/")[0]}` : id;
  const entry = getPlaceholder(pathKey) ?? getPlaceholder(id);
  const title = entry?.title ?? "این بخش";
  const homeRoute = activeRoleId ? role.homeRoute : "home";

  return (
    <main
      data-screen-label={`coming-soon · ${pathKey}`}
      className="page-shell"
      style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <EmptyState
        icon={<Icon name="sparkle" size={26} />}
        title={`${title} — به‌زودی`}
        body={
          <>
            این بخش در دست ساخت است و در گام‌های بعدی توسعه فعال می‌شود. ساختار
            ناوبری و دسترسی نقش شما درست تنظیم شده‌اند؛ به‌محض آماده‌شدن، محتوای
            واقعی همین‌جا نمایش داده می‌شود.
          </>
        }
        cta={
          <Button variant="primary" size="md" onClick={() => go(homeRoute)}>
            بازگشت به خانهٔ من
          </Button>
        }
      />
    </main>
  );
};

export default ComingSoonPage;
